//  index.js
//
//  Updated 1/25.
//
//  Abstract: Index of front-end. Renders App.js in 'root' HTML element.

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './services/reportWebVitals.js';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();